import React, {FC, useEffect, useMemo} from 'react'
import {KTCardBody} from '../../../../../../_metronic/helpers'
import {ColumnInstance, Row, useTable} from 'react-table'
import {getSiteColumns, sitesColumns} from './columns/_columns'
import {ESITE_QUERY_TYPE, Site} from '../core/_models'
import {CustomHeaderColumn} from './columns/CustomHeaderColumn'
import {CustomRow} from './columns/CustomRow'
import {
  useSiteQueryResponseData,
  useSiteQueryResponseFetchNextPage,
  useSiteQueryResponseHasMoreData,
  useSiteQueryResponseLoading,
} from '../core/SiteQueryResponseProvider'
import {useSiteProvider} from '../core/SiteProvider'

export const SitesTable = () => {
  const {company, site, setSite, isCompanyLoading, isSiteLoading, scrollTo, siteQueryType} =
    useSiteProvider()

  const {pages} = useSiteQueryResponseData()
  const hasMorePages = useSiteQueryResponseHasMoreData()
  const isLoading = useSiteQueryResponseLoading()
  const fetchNextPage = useSiteQueryResponseFetchNextPage()
  const columns = useMemo(
    () =>
      siteQueryType === ESITE_QUERY_TYPE.SITES_BY_COMPANY
        ? getSiteColumns(setSite, scrollTo)
        : sitesColumns,
    []
  )

  const data: Site[] = useMemo(() => {
    return pages ? pages.flatMap((page) => page.data?.Items || []) : []
  }, [pages])

  const {getTableProps, getTableBodyProps, headers, rows, prepareRow} = useTable({
    columns,
    data,
  })

  return (
    <KTCardBody className='py-4'>
      <div className='table-responsive'>
        <table
          id='kt_table_users'
          className='table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer'
          {...getTableProps()}
        >
          <thead>
            <tr className='text-start text-muted fw-bolder fs-7 text-uppercase gs-0'>
              {headers.map((column: ColumnInstance<Site>) => (
                <CustomHeaderColumn key={column.id} column={column} />
              ))}
            </tr>
          </thead>
          <tbody className='text-gray-600 fw-bold' {...getTableBodyProps()}>
            {rows.length > 0 ? (
              rows.map((row: Row<Site>, i) => {
                prepareRow(row)
                return <CustomRow row={row} key={`row-${i}-${row.id}`} />
              })
            ) : (
              <tr>
                <td colSpan={7}>
                  <div className='d-flex text-center w-100 align-content-center justify-content-center'>
                    No matching records found
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <button
        onClick={() => fetchNextPage()}
        className='btn btn-primary btn-sm mt-5'
        disabled={isLoading || !hasMorePages}
      >
        {!isLoading && 'Load More'}
        {isLoading && (
          <span className='indicator-progress' style={{display: 'block'}}>
            Loading... <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
          </span>
        )}
      </button>

      {/* {(isLoading || isFetchingNextPage) && <CompaniesListLoading />} */}
    </KTCardBody>
  )
}
